export default "__VITE_ASSET__Csuc58SF__"